import { Directive, HostBinding } from '@angular/core';

// This attaches the ngSkipHydration attribute to any components with maxLines
// as our truncation doesn't work with hydration.
// This needs to be a directive as it needs to be applied where the content is,
// which is usually in the highest-level component that has a `maxLines` input.
@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[maxLines], [flMaxLines]',
})
export class TextMaxLinesSkipHydrationDirective {
  @HostBinding('attr.ngSkipHydration') ngSkipHydration = 'true';
}
